import React from 'react';
import InternalBar from "../../TopLayout/InternalBar/InternalBar";
import {useHistory} from "react-router-dom";

function TaskCardMini({cards, scrollNav=()=>{}}) {
    const history = useHistory();
    const filteredItem = Array.isArray(cards) ? cards.slice(0, 2).filter((item) => !item?.isComplete) : [];
    return (
        <div className="task-card-mini-container">
            <h2>Complete tasks & <span>Win exciting rewards.</span></h2>
            {filteredItem?.map((item, index) => (
                <div className="task-card-mini" key={index}>
                    <h3>
                        {item?.task || "Task Name"}
                        <img
                            src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon.png"
                            alt="overview card forward"
                            height={12}
                        />
                    </h3>
                    {item?.statType === 3 ? (
                        <p>{item?.completedText || "Completed Text"}</p>
                    ) : (
                        <p>
                            {item?.total || 0} {item?.completedText || ""}
                        </p>
                    )}
                    <InternalBar height={12} width={item?.percentage || 0} />
                </div>
            ))}
            <button className="btn-action" onClick={() => {scrollNav(0);window.scrollTo({top: 0, behavior: 'smooth'});history.replace({pathname: "/tutor/details/tasks"});}}>
                View All Tasks
            </button>
        </div>
    );
}

export default TaskCardMini;
